import { UserSession } from '@com-delta-idp/mnx-skymiles-shared';
import { AffiliationList, SkyClubRequest } from '../models/api';

export const getSkyClubRequest = (
  userData: UserSession | undefined
): SkyClubRequest => {
  const affiliationList: AffiliationList[] = [];
  if (userData && userData.cobrandCardtypeList) {
    userData.cobrandCardtypeList
      .split(':')
      .forEach((type: string, index: number) => {
        if (['AXBV', 'AXCV'].includes(type))
          affiliationList.push({
            affiliationId:
              userData.cobrandCardtypeAffiliationIdList &&
              userData.cobrandCardtypeAffiliationIdList.split(':')[index],
            affiliationTypeCode: userData.cobrandCardtypeList.split(':')[index],
            affiliationTypeDesc:
              userData.cobrandCardtypeDescList &&
              userData.cobrandCardtypeDescList.split(':')[index]
          });
      });
  }
  return { affiliationList };
};
